webpackJsonp(["plugin--search-dropdown"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__vegkit/components/search/search-dropdown/keystroke.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyForKeyCode = keyForKeyCode;
exports.isAlphabet = isAlphabet;
exports.isEnter = isEnter;
exports.isEscape = isEscape;
exports.isNavigation = isNavigation;
exports.isNumber = isNumber;
exports.isWhitespace = isWhitespace;
exports.codeToString = codeToString;
var capAlpha = exports.capAlpha = {
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90
};

var lowAlpha = exports.lowAlpha = {
  A: 97,
  B: 98,
  C: 99,
  D: 100,
  E: 101,
  F: 102,
  G: 103,
  H: 104,
  I: 105,
  J: 106,
  K: 107,
  L: 108,
  M: 109,
  N: 110,
  O: 111,
  P: 112,
  Q: 113,
  R: 114,
  S: 115,
  T: 116,
  U: 117,
  V: 118,
  W: 119,
  X: 120,
  Y: 121,
  Z: 122
};

var navigation = exports.navigation = {
  KEY_PAGE_UP: 33,
  KEY_PAGE_DOWN: 34,
  KEY_END: 35,
  KEY_HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40
};

var numbers = exports.numbers = {
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57
};

var other = exports.other = {
  DASH: 189,
  ESCAPE: 27,
  SUBTRACT: 109
};

var whitespace = exports.whitespace = {
  TAB: 9,
  ENTER: 13,
  SPACE: 32
};

function keyForKeyCode(keyCode, object) {
  var keyLabel = null;

  Object.keys(object).forEach(function (key) {
    if (object[key] === keyCode) {
      keyLabel = key;
    }
  });

  return keyLabel;
}

function isAlphabet(keyCode) {
  return keyCode >= capAlpha.A && keyCode <= capAlpha.Z || keyCode >= lowAlpha.A && keyCode <= lowAlpha.Z;
}

function isEnter(keyCode) {
  return keyCode === whitespace.ENTER;
}

function isEscape(keyCode) {
  return keyCode === other.ESCAPE;
}

function isNavigation(keyCode) {
  return keyCode >= navigation.KEY_PAGE_UP && keyCode <= navigation.DOWN_ARROW;
}

function isNumber(keyCode) {
  return keyCode >= numbers[0] && keyCode <= numbers[9];
}

function isWhitespace(keyCode) {
  return keyCode === whitespace.SPACE || keyCode === whitespace.ENTER || keyCode === whitespace.TAB;
}

function codeToString(keyCode) {
  if (isAlphabet(keyCode) || isNumber(keyCode)) {
    return String.fromCharCode(keyCode);
  } else if (isNavigation(keyCode)) {
    return keyForKeyCode(keyCode, navigation);
  } else if (isWhitespace(keyCode)) {
    return keyForKeyCode(keyCode, whitespace);
  } else if (isEscape(keyCode)) {
    return 'ESCAPE';
  }

  return keyCode;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__vegkit/components/search/search-dropdown/plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _keystroke = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__vegkit/components/search/search-dropdown/keystroke.js");

var _keystroke2 = _interopRequireDefault(_keystroke);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__vegkit/components/search/search-dropdown/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('components/' + _index.PLUGIN_NAME);

var SearchDropdownPlugin = function () {
	function SearchDropdownPlugin(element, options) {
		_classCallCheck(this, SearchDropdownPlugin);

		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.options.typingDebounceMs = parseInt(this.options.typingDebounceMs);

		this.options.escapeKeyCodes = this.options.escapeKeyCodes.split(' ');
		this.options.ignoreKeyCodes = this.options.ignoreKeyCodes.split(' ');

		this.hasFocus = false;
		this.focsusedElement = null;
		this.searchCancelled = false;

		this.searchField = this.selectors.selectTarget(this.options.searchInputSelector, this.$element);
		this.submitButton = this.selectors.selectTarget(this.options.searchSubmitSelector, this.$element);
		this.cancelButton = this.selectors.selectTarget(this.options.searchCancelSelector, this.$element);
		this.resultsContainer = this.selectors.selectTarget(this.options.resultsContainerSelector, this.$element);

		this.templateSource = this.selectors.selectTarget(this.options.dropdownTemplateSelector, this.$element);
		this.template = this.templateSource.text();
		this.templateSource.data('original-content', this.template);
		this.templateSource.empty();

		window.strings = this.strings;

		this.watch();

		log('ready', this.$target);
	}

	_createClass(SearchDropdownPlugin, [{
		key: 'watch',
		value: function watch() {
			var _this = this;

			var debounceImmediate = this.options.typingDebounceEdge === 'leading';
			this.searchField.on('keyup', this.fn.debounce(this.send.bind(this), this.options.typingDebounceMs, debounceImmediate));

			// Respond to clear search button click (IE/Edge)
			this.searchField.on('mouseup', function () {
				var input = _this.searchField;
				var oldValue = input.val();
				if (oldValue === '') {
					return false;
				}
				setTimeout(function () {
					var newValue = input.val();
					if (newValue === '') {
						_this.cancel();
					}
				}, 0);
			});

			(0, _jquery2.default)(document).on('click', function (event) {
				var hasTarget = _this.$element.has(event.target);
				if (hasTarget && hasTarget.length) {
					_this.open();
				} else {
					_this.close();
				}
			});

			this.cancelButton.on('click', function () {
				log('cancelClick');
				_this.cancel();
			});

			log('watching');
		}
	}, {
		key: 'send',
		value: function send(event) {
			var _this2 = this;

			this.close();
			var query = this.searchField.val();
			var keyCode = event.keyCode;
			var _options = this.options,
			    ignoreKeyCodes = _options.ignoreKeyCodes,
			    escapeKeyCodes = _options.escapeKeyCodes,
			    minQueryLength = _options.minQueryLength,
			    errorClass = _options.errorClass,
			    sendingClass = _options.sendingClass,
			    openClass = _options.openClass,
			    url = _options.url;


			log('send', query);

			if (query && query.length < minQueryLength) {
				this.$element.trigger(_index.PLUGIN_NAME + '.notMinLength');

				log('minQueryLength', query.length);
				return;
			} else if (ignoreKeyCodes.includes('' + keyCode)) {
				this.$element.trigger(_index.PLUGIN_NAME + '.keyIgnored', { keyCode: keyCode });

				log('key[' + event.keyCode + '] ignored since it\'s in options.ignoreKeyCodes[' + ignoreKeyCodes + ']');
				return;
			} else if (escapeKeyCodes.includes('' + event.keyCode)) {
				this.$element.trigger(_index.PLUGIN_NAME + '.escape');
				log('key[' + event.keyCode + '] triggered close since it\'s in options.escapeKeyCodes[' + escapeKeyCodes + ']');

				this.close();
				return;
			} else if (query && query.length) {
				this.submitButton.attr('disabled', true);
				this.$element.trigger(_index.PLUGIN_NAME + '.beforeSend');
				this.$element.addClass(sendingClass);
				this.$element.removeClass(errorClass);

				_jquery2.default.ajax({
					url: url,
					data: {
						q: query
					},
					success: function success(data, status, request) {
						log('success', data, status);

						_this2.$element.removeClass(errorClass);
						_this2.render(data);
						_this2.$element.addClass(openClass);
						_this2.$element.trigger(_index.PLUGIN_NAME + '.rendered');
					},
					error: function error(data, status, request) {
						log('error', data, status);

						_this2.$element.removeClass(openClass);
						_this2.$element.addClass(errorClass);
						_this2.$element.trigger(_index.PLUGIN_NAME + '.error', {
							data: data,
							status: status,
							request: request
						});
					},
					complete: function complete() {
						_this2.$element.removeClass(sendingClass);
						_this2.submitButton.removeAttr('disabled');
					}
				});
			} else {
				this.cancel();
			}

			this.$element.trigger(_index.PLUGIN_NAME + '.afterSend');
		}
	}, {
		key: 'onFocusChanged',
		value: function onFocusChanged(event) {
			log('onFocusChanged', event);
			this.focusedElement = event.toElement;
			var hasFocus = this.$element.has(this.focusedElement);
			this.hasFocus = hasFocus && hasFocus.length > 0;

			logger.log('onFocusIn.hasFocus', this.hasFocus);

			if (!this.hasFocus) {
				this.fn.debounce(this.close.bind(this), 50);
			}
		}
	}, {
		key: 'render',
		value: function render(data) {
			log('render', data, this.template);
			var context = Object.keys(data).reduce(function (result, key) {
				var value = data[key];
				result[key] = value;
				if (Array.isArray(value)) {
					result[key + 'IsEmpty'] = value.length === 0;
				}
				return result;
			}, {});
			var html = this.strings.mustache(this.template, context);
			log('rendered', html);
			this.resultsContainer.html(html);
		}
	}, {
		key: 'reset',
		value: function reset(event) {
			log('reset');
			this.submitButton.removeAttr('disabled');
			this.searchField.val('');
			this.searchField.EmitOnDirty('clean');
			this.resultsContainer.empty();
		}

		// Display suggestions

	}, {
		key: 'open',
		value: function open() {
			log('open');
			this.$element.addClass(this.options.openClass);
			this.$element.trigger(_index.PLUGIN_NAME + '.open');
		}
	}, {
		key: 'close',
		value: function close() {
			log('close');
			this.$element.removeClass(this.options.hasErrorClass);
			this.$element.removeClass(this.options.sendingClass);
			this.$element.removeClass(this.options.openClass);
			this.$element.trigger(_index.PLUGIN_NAME + '.closed');
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			log('cancel');
			this.searchCancelled = true;
			this.reset();
			this.close();
		}
	}]);

	return SearchDropdownPlugin;
}();

SearchDropdownPlugin.DEFAULTS = {
	/*
  http://keycode.info/
    9 = tab
    16 = shift
    17 = ctrl
    18 = alt
    37 = left
    38 = up
    39 = right
    40 = down
    32 = space
    91 = left super
    92 = right super
    //https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#Constants_for_keyCode_value
  */
	minQueryLength: 3,
	ignoreKeyCodes: '9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224',
	escapeKeyCodes: '27',
	searchInputSelector: '(here) [data-search-dropdown__input-field]',
	searchCancelSelector: '(here) [data-search-dropdown__cancel-button]',
	searchSubmitSelector: '(here) [data-search-dropdown__submit-button]',
	dropdownTemplateSelector: '(here) [data-search-dropdown__result-container]',
	resultsContainerSelector: '(here) [data-search-dropdown__result-container]',
	typingDebounceMs: 500,
	typingDebounceEdge: 'trailing',
	openClass: 'search-dropdown--is-open',
	sendingClass: 'search-dropdown--is-sending',
	errorClass: 'search-dropdown--error',
	placement: 'bottom',
	placementTarget: '(self)'
};

(0, _lib2.default)(_index.PLUGIN_NAME, SearchDropdownPlugin);

/***/ })

});


// WEBPACK FOOTER //
// scripts/plugin--search-dropdown--54021585f3e24df7f8d2.js